import { useEffect, useState } from 'react';
// function to round a number to 1 decimal
const roundNumber = (num) => {
    return Math.round((num + Number.EPSILON) * 10) / 10;
};
const colorValues = [
    '#695CFF',
    '#2AB1EB',
    '#FF63D3',
    '#00CFB6',
    '#FFB800',
    '#F04A4A',
    '#65C702',
    '#F48218',
    '#000080',
    '#D3D3D3'
];
// Índice global para recorrer el arreglo de colores
let colorIndex = 0;
// Función para obtener el siguiente color en orden
function getNextColor() {
    const color = colorValues[colorIndex];
    colorIndex = (colorIndex + 1) % colorValues.length;
    return color;
}
const MAIN_CATEGORIES = [{ title: 'EMPTY', color: '#D3D3D3', value: 100, amount: 0 }];
export const useChartPositions = ({ items }) => {
    const [chartDataArray, setChartDataArray] = useState(MAIN_CATEGORIES);
    const [total, setTotal] = useState(0);
    const initValues = () => {
        // const localCategories = MAIN_CATEGORIES.filter(i => i.title !== 'EMPTY').map(item => ({ ...item }));
        const totalAmountSpent = items.reduce((accumulator, currentValue) => accumulator + Number(currentValue.customAmount), 0);
        const resultCategories = items.map(item => {
            return {
                title: item === null || item === void 0 ? void 0 : item.stockName,
                color: getNextColor(),
                value: roundNumber(((item === null || item === void 0 ? void 0 : item.customAmount) * 100.0) / totalAmountSpent),
                amount: item === null || item === void 0 ? void 0 : item.customAmount
            };
        });
        setChartDataArray(resultCategories);
        setTotal(totalAmountSpent);
    };
    useEffect(() => {
        if (items.length > 0) {
            initValues();
        }
    }, [items.length]);
    return {
        chartData: chartDataArray,
        total
    };
};
